document.addEventListener("DOMContentLoaded", function() {
    // Sélectionner uniquement les divs avec la classe "product__text--content"
    var hexDivs = document.querySelectorAll('div.product__text--content');

    hexDivs.forEach(function(div) {
        var content = div.textContent.trim();
        // Vérifier que le contenu correspond exactement au format "hexa##:#[0-9A-Fa-f]{6}"
        if (/^hexa##:#[0-9A-Fa-f]{6}$/.test(content)) {
            // Extraire la valeur hexadécimale en retirant le préfixe et en supprimant les espaces éventuels
            var colorValue = content.split('hexa##:')[1].trim();

            // (Redondant ici, mais pour être sûr) Vérifier que la couleur est valide
            if (/^#[0-9A-Fa-f]{6}$/.test(colorValue)) {
                // Appliquer la couleur à l'élément avec la classe 'announcement-bar.bar.js-announcement-bar'
                var announcementBar = document.querySelector('.announcement-bar.bar.js-announcement-bar');
                if (announcementBar) {
                    announcementBar.style.backgroundColor = colorValue;
                }

                // Appliquer la couleur à tous les éléments ayant la classe 'product__title'
                var productTitles = document.querySelectorAll('.product__title');
                productTitles.forEach(function(productTitle) {
                    productTitle.style.color = colorValue;
                });

                // Appliquer la couleur à tous les éléments ayant la classe 'product-form__submit'
                var submitButtons = document.querySelectorAll('.product-form__submit');
                submitButtons.forEach(function(submitButton) {
                    submitButton.style.backgroundColor = colorValue;
                });


var ratingSegments = document.querySelectorAll('.product__feature-rating-segment.active');
ratingSegments.forEach(function(segment) {
    segment.style.backgroundColor = colorValue;
});
              
            } else {
                console.error('La couleur hexadécimale est invalide');
            }
            
            // Supprimer uniquement cette div
            div.remove();
        }
    });
});
